export default __webpack_public_path__ + "static/media/logo.47b27b20.png";